import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEAmbossTargetType = {
    head:               'head',
    anatomy:            'anatomy',
    biology:            'biology',
    organs:             'organs',
};

OEAmbossTargetType.all = [
    OEAmbossTargetType.head,
    OEAmbossTargetType.anatomy,
    OEAmbossTargetType.biology,
    OEAmbossTargetType.organs
];

export const OEAmbossStartSelectionContent = {

    [OEAmbossTargetType.head]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanLarynx,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.surgeryEyeCataract,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanSkinMacro
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
// @ADD_TARGET_AMBOSS_TARGETMENU
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.organs]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.biology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.virusSarscov2
                    ]
                }
            ]
        }
    ],

    // beta
    [OEAmbossTargetType.head + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanLarynx,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.surgeryEyeCataract,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanSkinMacro
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.organs + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.biology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.virusSarscov2
                    ]
                }
            ]
        }
    ],

    // prod
    [OEAmbossTargetType.head + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanHead,
                        OETargetMenuDefs.humanSkull,
                        OETargetMenuDefs.humanCNS,
                        OETargetMenuDefs.humanCranialNerves,
                        OETargetMenuDefs.humanLarynx,
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.surgeryEyeCataract,
                        OETargetMenuDefs.humanEarMacro,
                        OETargetMenuDefs.humanEarInner,
                        OETargetMenuDefs.humanEarMicro,
                        OETargetMenuDefs.humanSkinMacro
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanArm,
                        OETargetMenuDefs.humanShoulderGirdle,
                        OETargetMenuDefs.humanUpperArmElbow,
                        OETargetMenuDefs.humanForearm,
                        OETargetMenuDefs.humanHand
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanLeg,
                        OETargetMenuDefs.humanHip2,
                        OETargetMenuDefs.humanThighKnee,
                        OETargetMenuDefs.humanLowerLeg,
                        OETargetMenuDefs.humanAnkleFoot
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanTrunk,
                        OETargetMenuDefs.humanNeckBack,
                        OETargetMenuDefs.humanChestWall,
                        OETargetMenuDefs.humanAbdominalWall,
                        OETargetMenuDefs.humanPelvis,
                        OETargetMenuDefs.humanSpine
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.organs + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanTrunkVessel
                    ]
                }
            ]
        }
    ],

    [OEAmbossTargetType.biology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanCellEpithelium,
                        OETargetMenuDefs.virusSarscov2,
                    ]
                }
            ]
        }
    ]
};

OEAmbossStartSelectionContent.modules = [
    {id: OEAmbossTargetType.head, icon: OEIconCodes.amboss.headTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.head]},
    {id: OEAmbossTargetType.anatomy, icon: OEIconCodes.amboss.anatomyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.anatomy]},
    {id: OEAmbossTargetType.organs, icon: OEIconCodes.amboss.organsTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.organs]},
    {id: OEAmbossTargetType.biology, icon: OEIconCodes.amboss.biologyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.biology]}
];

OEAmbossStartSelectionContent.modulesBeta = [
    {id: OEAmbossTargetType.head, icon: OEIconCodes.amboss.headTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.head + OEAlphaBetaProdTypes.beta]},
    {id: OEAmbossTargetType.anatomy, icon: OEIconCodes.amboss.anatomyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEAmbossTargetType.organs, icon: OEIconCodes.amboss.organsTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.organs + OEAlphaBetaProdTypes.beta]},
    {id: OEAmbossTargetType.biology, icon: OEIconCodes.amboss.biologyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.biology + OEAlphaBetaProdTypes.beta]}
];

OEAmbossStartSelectionContent.modulesProduction = [
    {id: OEAmbossTargetType.head, icon: OEIconCodes.amboss.headTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.head + OEAlphaBetaProdTypes.prod]},
    {id: OEAmbossTargetType.anatomy, icon: OEIconCodes.amboss.anatomyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEAmbossTargetType.organs, icon: OEIconCodes.amboss.organsTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.organs + OEAlphaBetaProdTypes.prod]},
    {id: OEAmbossTargetType.biology, icon: OEIconCodes.amboss.biologyTarget, categories: OEAmbossStartSelectionContent[OEAmbossTargetType.biology + OEAlphaBetaProdTypes.prod]}
];